import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatMoneyCents } from "@/core/utils/money";
import type { StAdjustmentTechnicianGroup } from "@/payroll/pay-breakdown/st-adjustments/types";
import { isPushableGroup } from "@/payroll/pay-breakdown/st-adjustments/utils";

// The money about to move, so the pending amount leads. The period total sits
// under it only when the two differ — otherwise it's the same number twice.
export const AMOUNT_COLUMN: ColumnDef<StAdjustmentTechnicianGroup, unknown> = {
  id: "amount",
  header: "Pending amount",
  enableSorting: false,
  meta: { size: "12rem" },
  cell: ({ row }) => {
    const group = row.original;
    const pushable = isPushableGroup(group);
    const leadCents = pushable
      ? group.pending_amount_cents
      : group.amount_cents;
    const showsTotal =
      pushable && group.pending_amount_cents !== group.amount_cents;

    return (
      <Stack gap="none" fullWidth>
        <Typography variant="bodyW1">
          {formatMoneyCents(leadCents) ?? "$0"}
        </Typography>
        {showsTotal && (
          <Typography variant="bodyW2" textColor="secondary">
            of {formatMoneyCents(group.amount_cents) ?? "$0"}
          </Typography>
        )}
      </Stack>
    );
  },
};
